<template>
    <div class="questionnaire">
        <v-card :flat="phoneOnly" max-width="550" class="mx-auto" :class="{'soft-shadow px-3 py-2': pcOnly, 'transparent px-0': phoneOnly}">
            <v-card-title>املأ الاستبيان</v-card-title>
            <v-card-subtitle>الرجاء ادراج الخدمات التي تقدمها في البازار.</v-card-subtitle>
            <v-card-text class="mt-5" :class="{'px-0': phoneOnly}">
                <v-alert v-if="sentOnce" color="blue darken-3" dense type="success" text>
                    <div class="medium-text">شكراً لك لملء الاستبيان، لقد استلمنا بياناتك.</div>
                </v-alert>
                <v-form class="mx-auto" style="max-width: 550px">
                    <v-select v-model="provides" :disabled="disabled || sentOnce" outlined label="ماذا تقدم؟" placeholder="ماذا تقدم؟" :items="items"></v-select>
                    <v-textarea v-model="description" :disabled="disabled || sentOnce" rows="8" outlined :label="label" :placeholder="placeholder" no-resize></v-textarea>
                    <v-btn :disabled="disabled || sentOnce" :loading="loading" large color="primary" block @click.prevent="submitAction">حفظ البيانات</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    data(){
        return {
            items: [
                {text: 'خدمة', value: 'service'},
                {text: 'منتج', value: 'product'}
            ],
            provides: '',
            description: '',

            disabled: false,
            loading: false,

            sentOnce: false,
        }
    },
    computed: {
        label(){
            return this.provides === 'service' ? 'الخدمات التي تقدمها' : 'المنتجات التي تقدمها';
        },
        placeholder(){
            return this.provides === 'service' ? 'اذكر الخدمات التي تقدمها' : 'اذكر اسم المنتج ونوعه وفيم يُستخدم';
        },
        ...GlobalComputed
    },
    watch: {
        user(){
            this.syncWithUser();
        }
    },
    methods: {
        syncWithUser(){
            const user = this.user;
            if (user && user.questionnaire){
                this.disabled = true;
                this.provides = user.questionnaire.provides;
                this.description = user.questionnaire.description;
            }
        },
        submitAction(){
            if (!this.loading){
                let data = this.validate();
                if (data){
                    this.loading = true;

                    this.$store.dispatch('fastPostAction', {url: `/questionnaire`, data}).then((response)=>{
                        this.showMsg('تم إرسال البيانات بنجاح', 'success');
                        this.loading = false;
                        this.disabled = true;
                        
                    }).catch((e)=>{
                        this.showMsg("حدثت مشكلة أثناء اﻹرسال");
                        this.loading = false;
                    })

                }else{
                    this.showMsg("لا يمكنك ترك حقل فارغاً");
                }
            }
        },
        validate(){
            if (this.provides && this.description.trim()){
                return {
                    provides: this.provides,
                    description: this.description,
                };
            }else{
                return false;
            }
        },
        ...GlobalMethods
    },
    mounted(){
        this.syncWithUser();
        if (this.user.questionnaire){
            this.sentOnce = true;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>